﻿import * as React from 'react';
import {Translate} from "../../../shared/LanguageService";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import FormSelect from "../../../components/common/FormSelect";
import {useState} from "react";
import BrokersApi from "../BrokersApi";
interface IProps {
    profileColor: string | null;
    onChange: (e: any) => void;
    updateProfileColor: (profileColor: string) => void;
    profileLogo: File | null;
    onFileChange: (file: File) => void;
    imagePreviewUrl: string;
    firmId: number;
    chainId: number;
}
const ShowcaseSettings = (props: IProps) => {
    const [inputValue, setInputValue] = useState(props.profileColor || '');
    const [selectedOption, setSelectedOption] = useState('');
    const [isValidColor, setIsValidColor] = useState(false);
    const handleColorChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        const isColorValid = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(newValue);
        if (isColorValid) {
            props.updateProfileColor(newValue);
        }
        setIsValidColor(isColorValid);
    }
    const handleOptionChange = (e) => {
        const newValue = e.target.value;
        setSelectedOption(newValue);
        let firmOrChainId = props.firmId ? props.firmId : props.chainId;
        if (newValue === '1' && firmOrChainId) {
            handleFileUpload();
            setSelectedOption("0")
        }
        if (newValue === '2' && firmOrChainId) {
            removeFile();
            setSelectedOption("0")
        }
    };
    const handleFileUpload = () => {
        const fileInput = document.getElementById('fileInput');
        if (fileInput) {
            fileInput.click();
        }
    };
    const removeFile = () => {
        if (props.profileLogo) {
            props.firmId ? BrokersApi.removeFileFirmProfileSettings(props.firmId) : BrokersApi.removeFileChainProfileSettings(props.chainId)
            props.onFileChange(null);
        }
    }
    const handleLogoChange = (e) => {
        const profileLogo = e.target.files[0];
        props.onFileChange(profileLogo)
    };
    return (
        <fieldset>
            <legend>{Translate('broker/ordersources/form/showcase')}</legend>
            <Row>
                <Col sm={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker/ordersources/form/showcase/profilecolor')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="profileColor"
                            value={inputValue}
                            onChange={handleColorChange}
                            placeholder="#FEFEFE"
                        />
                        {inputValue.length > 0 && isValidColor && (
                            <div>
                                {Translate('broker/ordersources/form/tab/showcase/profilecolor')}
                                <div
                                    style={{
                                        width: '100px',
                                        height: '40px',
                                        backgroundColor: inputValue,
                                    }}
                                ></div>
                            </div>
                        )
                        }
                        {!isValidColor && inputValue.length > 0 && (
                            <div>
                                {Translate('broker/ordersources/form/tab/showcase/invalidprofilecolor')}
                            </div>
                        )}
                    </FormGroup>
                </Col>
                <Col sm={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('broker/ordersources/form/showcase/logotype')}
                        </ControlLabel>
                        <FormSelect
                            name="selectedColor"
                            value={selectedOption}
                            onChange={handleOptionChange}
                        >
                            <option value="0" key="0">
                                {props.profileLogo ? props.profileLogo.name : Translate('broker/ordersources/form/showcase/uploadlogotype')}
                            </option>
                            <option value="1" key="1">
                                {Translate('broker/ordersources/form/upload')}
                            </option>
                            <option value="2" key="2">
                                {Translate('broker/ordersources/form/remove')}
                            </option>
                        </FormSelect>
                    </FormGroup>
                    <input
                        type="file"
                        id="fileInput"
                        style={{display: 'none'}}
                        onChange={handleLogoChange}
                    />
                    {props.imagePreviewUrl && (
                        <div>
                            <img src={props.imagePreviewUrl} style={{maxHeight: 160}}/>
                        </div>
                    )}
                </Col>
            </Row>
        </fieldset>
    );
}
export default ShowcaseSettings;